import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class MainService {

    appReady = new BehaviorSubject(false);
    apiUrl = 'https://testfinanceplus.proventum.me';

    constructor() {
    }

}
